import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enAU from "../locales/en-AU/translation.json";
import enCA from "../locales/en-CA/translation.json";
import enGB from "../locales/en-GB/translation.json";
import enUS from "../locales/en-US/translation.json";
import frCA from "../locales/fr-CA/translation.json";

export const i18nextOptions = {
  resources: {
    en: { translation: enUS },
    "en-US": { translation: enUS },
    "en-CA": { translation: enCA },
    "en-GB": { translation: enGB },
    "en-AU": { translation: enAU },
    fr: { translation: frCA },
    "fr-CA": { translation: frCA },
  },

  returnNull: false,

  fallbackLng: "en-US",

  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: [
      "querystring",
      "cookie",
      "localStorage",
      "sessionStorage",
      "navigator",
    ],
    lookupQuerystring: "locale",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
  },
  react: {
    transSupportBasicHtmlNodes: false,
  },
};

i18n.use(initReactI18next).use(LanguageDetector).init(i18nextOptions);

export default i18n;
